export default function appSettings() {
    return window._APP_SETTINGS;
}
